<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="loco-status-top-buttons">

    <button type="button" tabindex="{{tabIndex + 2}}" disabled="{{(user && user.isUserManagerOrDirector) && isSelectedLocos ? '' : 'disabled'}}" [ngClass]="(user && user.isUserManagerOrDirector) && isSelectedLocos ? 'p-button-secondary' : 'p-button-disabled'" (click)="openPlanOrCurrentAssignmentPopup('planLocomotive');">
  <span class="fa fa-exchange"></span>
      {{configData && configData.locoStatusLabel.planLocomotive}}
   </button>

    <button type="button" tabindex="{{tabIndex + 4}}" disabled="{{(user && user.isUserManagerOrDirector) && isShowCancelLocoPlan ? '' : 'disabled'}}" [ngClass]="(user && user.isUserManagerOrDirector) && isShowCancelLocoPlan ? 'p-button-secondary ml-3' : 'p-button-disabled ml-3'"
        (click)="openCancelLocomotivePlanPopup();">
    <span class="fa fa-ban"></span>
       {{configData && configData.locoStatusLabel.cancelLocomotivePlan}}
  </button>

    <button type="button" tabindex="{{tabIndex + 6}}" disabled="{{(user && user.isUserManagerOrDirector) && isSelectedLocos ? '' : 'disabled'}}" [ngClass]="(user && user.isUserManagerOrDirector) && isSelectedLocos ? 'p-button-secondary ml-3' : 'p-button-disabled ml-3'" (click)="openPlanOrCurrentAssignmentPopup('setCurrentAssignment');">
    <span class="fa fa-map-marker"></span>
     {{configData && configData.locoStatusLabel.setCurrentAssignment}}
  </button>
  <div class="other-actions loco-status">
    <p-splitButton #locoStatusSplitBtn [disabled]="!isSelectedLocos || (user && !user.isUserManagerOrDirector)" id='locoStatusSplitBtn' styleClass="split-button-ui {{ (!isSelectedLocos || (user && !user.isUserManagerOrDirector)) ? 'p-state-disabled' : ''}}" label="Other Actions" [model]="otherOptions"
        tabindex="{{tabIndex + 7}}">
    </p-splitButton>
  </div>
</div>